<template>
  <div style="position: relative; width: 100%; text-align: center;">
    <v-progress-circular size="64" indeterminate color="blue" style="margin: 0 auto; margin-bottom: 30px;" />
    <div class="subheading unselectable loading-dots" style="text-align: center">
      Loading {{ resourceName }}
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      resourceName: String,
    },
  }
</script>